import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useToast,
} from '@chakra-ui/react';
import { AxiosError } from 'axios';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { UIErrorResponse } from 'types/src/error';
import { bookNowApi } from '../../apis/contact';
import { useDomainConfig } from '../../hooks/useDomainConfig';
import { useUser, useUserProfile } from '../../hooks/V2/useUser';
import { useGetRequestCallback } from '../../hooks/V2/useRequestCallback';
import { createRequestCallback } from '../../apis/V2/requestCallback';
import RequestCallback from './V2/RequestCallback';

interface BookDemoFormProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
}

interface BookDemoFormInput {
	// name: string;
	// email: string;
	// phoneNumber: string;
	date: string;
}

function BookDemoForm({ isOpen, onClose, title }: BookDemoFormProps) {
	return (
		<RequestCallback sourceType='' openCallbackDrawer={isOpen} setOpenCallbackDrawer={onClose} />
		// <Modal isCentered isOpen={isOpen} onClose={onClose}>
		// 	<ModalOverlay />
		// 	<ModalCloseButton />
		// 	<ModalContent>
		// 		<ModalHeader>{title}</ModalHeader>
		// 		<ModalBody>
		// 			<Box as="form" onSubmit={handleSubmit(onSubmit)}>
		// 				{/* <FormControl id="name" mb="24px" isInvalid={errors.email ? true : false}>
		// 					<Text as={FormLabel} textStyle="body2-md">
		// 						Name
		// 					</Text>
		// 					<Input type="name" placeholder="julie@example.com" {...register('name', { required: 'Please enter your name' })} />
		// 					{errors.name && (
		// 						<Text textStyle="body2" mt="6px" color="#D61E27">
		// 							{errors.name.message}
		// 						</Text>
		// 					)}
		// 				</FormControl>
		// 				<FormControl id="email" mb="24px" isInvalid={errors.email ? true : false}>
		// 					<Text as={FormLabel} textStyle="body2-md">
		// 						Email
		// 					</Text>
		// 					<Input type="email" placeholder="julie@example.com" {...register('email', { required: 'Email is required' })} />
		// 					{errors.email && (
		// 						<Text textStyle="body2" mt="6px" color="#D61E27">
		// 							{errors.email.message}
		// 						</Text>
		// 					)}
		// 				</FormControl>
		// 				<FormControl id="phoneNumber" mb="24px" isInvalid={errors.email ? true : false}>
		// 					<Text as={FormLabel} textStyle="body2-md">
		// 						Phone Number
		// 					</Text>
		// 					<Input type="text" placeholder="julie@example.com" {...register('phoneNumber', { required: 'Phone number is required' })} />
		// 					{errors.phoneNumber && (
		// 						<Text textStyle="body2" mt="6px" color="#D61E27">
		// 							{errors.phoneNumber.message}
		// 						</Text>
		// 					)}
		// 				</FormControl> */}
		// 				<FormControl id="date" mb="24px" isInvalid={errors.date ? true : false}>
		// 					<Text as={FormLabel} textStyle="body2-md">
		// 						Preferred Date
		// 					</Text>
		// 					<Input min={today} type="datetime-local" placeholder="--/--" {...register('date', { required: 'Please select a date' })} />
		// 					{errors.date && (
		// 						<Text textStyle="body2" mt="6px" color="#D61E27">
		// 							{errors.date.message}
		// 						</Text>
		// 					)}
		// 				</FormControl>
		// 			</Box>
		// 		</ModalBody>
		// 		<ModalFooter>
		// 			<Button onClick={onClose}>Cancel</Button>
		// 			<Button isLoading={isBooking} onClick={handleSubmit(onSubmit)} colorScheme="blue" ml={3} type="submit">
		// 				Submit
		// 			</Button>
		// 		</ModalFooter>
		// 	</ModalContent>
		// </Modal>
	);
}

export default BookDemoForm;
